import { render, staticRenderFns } from "./RichTextContent.vue?vue&type=template&id=836975f2&lang=pug&"
import script from "./RichTextContent.vue?vue&type=script&lang=js&"
export * from "./RichTextContent.vue?vue&type=script&lang=js&"
import style0 from "./RichTextContent.vue?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports